import React from 'react';

/**
 * Inline banner.
 *   <Alert type="error" onDismiss={() => setError(null)}>{error}</Alert>
 * type: 'error' | 'success' | 'info' | 'warning'
 */
export default function Alert({ type = 'info', children, onDismiss }) {
  if (!children) return null;
  return (
    <div className={`alert alert-${type}`} role={type === 'error' ? 'alert' : 'status'}>
      <div className="alert-content">{children}</div>
      {onDismiss && (
        <button type="button" className="alert-close" onClick={onDismiss} aria-label="Dismiss">
          ×
        </button>
      )}
    </div>
  );
}
